// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1-gnF","title":"AfterBackImages_title__3KVBc","images":"AfterBackImages_images__1SlWd"};